import { useEffect, useState } from 'react';

import bscLogo from '../../../common/svg/sidebar/header/bsc-logo.svg';
import ethLogo from '../../../common/svg/sidebar/header/icon-eth-small.svg';
import { ListingType } from '../../../lib/graph/MogulMarketplace';
import type { rangeOptions } from './OptionsRange.component';
import { OptionsRange } from './OptionsRange.component';
import { OptionsSelect } from './OptionsSelect.component';
export interface searchOptions {
  network: string;
  sortBy: string;
  sortDirection: string;
  range: rangeOptions | undefined;
  listingType: string;
}

interface Props {
  setSearchOptions: React.Dispatch<
    React.SetStateAction<searchOptions | undefined>
  >;
}

export const SearchOptions: React.FC<Props> = props => {
  const [selectedNetwork] = useState(0);
  const networkOptions = [
    { label: 'All', value: 'all', id: 'allNet' },
    {
      label: 'ETH',
      value: 'eth',
      id: 'ethNet',
      logo: ethLogo,
      height: '30',
      width: '30',
      logoTailwind: '-ml-2 -mr-1',
    },
    {
      label: 'BSC',
      value: 'bsc',
      id: 'bscNet',
      logo: bscLogo,
      height: '15',
      width: '15',
      logoTailwind: 'mr-1',
    },
  ];

  const [selectedSort, setSelectedSort] = useState(0);
  const sortOptions = [
    { label: 'Most Recent', value: 'recent', id: 'sortRecent' },
    { label: 'Alphabetical (A-Z)', value: 'alphaAsc', id: 'sortAlphAsc' },
    { label: 'Alphabetical (Z-A)', value: 'alphaDesc', id: 'sortAlphDesc' },
    { label: 'Price: High to Low', value: 'HightoLow', id: 'sortPriceDesc' },
    { label: 'Price: Low to High', value: 'LowtoHigh', id: 'sortPriceAsc' },
  ];

  const [rangeData, setRangeData] = useState<rangeOptions | undefined>({
    netOption: 'bsc',
    minVal: '',
    maxVal: '',
  });

  const [selectedType, setSelectedType] = useState(0);
  const typeOptions = [
    { label: 'All', value: '', id: 'typeAll' },
    { label: 'Listed Sales', value: ListingType.Listing, id: 'typeSales' },
    { label: 'Listed Auctions', value: ListingType.Auction, id: 'typeAuct' },
  ];

  useEffect(() => {
    let sortType = '';
    let direction = '';

    if (sortOptions[selectedSort].value === 'recent') {
      sortType = 'mintedTime';
      direction = 'desc';
    } else if (sortOptions[selectedSort].value === 'alphaAsc') {
      sortType = 'title';
      direction = 'asc';
    } else if (sortOptions[selectedSort].value === 'alphaDesc') {
      sortType = 'title';
      direction = 'desc';
    } else if (sortOptions[selectedSort].value === 'HightoLow') {
      sortType = 'displayPrice';
      direction = 'desc';
    } else if (sortOptions[selectedSort].value === 'LowtoHigh') {
      sortType = 'displayPrice';
      direction = 'asc';
    }

    props.setSearchOptions({
      network: networkOptions[selectedNetwork].value,
      sortBy: sortType,
      sortDirection: direction,
      range: rangeData,
      listingType: typeOptions[selectedType].value,
    });
  }, [selectedNetwork, selectedSort, rangeData, selectedType]);

  return (
    <div className="flex flex-row justify-start flex-wrap gap-x-10 mx-4 sm:mx-0">
      {/* uncomment when networktypes are supported */}
      {/* <div className="mr-16 mt-3">
        <OptionsSelect
          label="Network"
          tailwindBase={'lg:w-20 w-40'}
          tailwindDropdown={'lg:w-20 w-32 lg:pl-3 pl-12 lg:pr-4 pr-3'}
          selected={selectedNetwork}
          setSelected={setSelectedNetwork}
          listOptions={networkOptions}
        />
      </div> */}

      <div className="mt-3">
        <OptionsSelect
          label="Sort By"
          tailwindBase={'lg:w-48 md:w-40 w-full'}
          tailwindDropdown={'lg:w-48 w-40 lg:pl-7 pl-4 lg:pr-0 pr-3'}
          selected={selectedSort}
          setSelected={setSelectedSort}
          listOptions={sortOptions}
          defaultListOption={selectedSort}
        />
      </div>

      <div className="mt-3">
        <OptionsRange
          label="Price Range"
          tailwindWidth={'md:w-40 w-full'}
          setRangeOptions={setRangeData}
        />
      </div>

      <div className="mt-3">
        <OptionsSelect
          label="Listing Type"
          tailwindBase={'md:w-40 w-full'}
          tailwindDropdown={'w-40 pl-6 pr-1'}
          selected={selectedType}
          setSelected={setSelectedType}
          listOptions={typeOptions}
        />
      </div>
    </div>
  );
};
